<template>
  <div class="row mb-3 mx-0">
    <section class="col-12 col-md bg-white rounded p-4 p-xl-5">
      <h1 class="h3 mb-4">Account Overview</h1>

      <div class="d-flex justify-content-between">
        <div class="flex-grow-1">
          <h2 class="h5 mb-3">Your Details</h2>
          <span class="text-muted" style="line-height: 1.7;">
            {{ user.title }} {{ user.first_name }} {{ user.last_name }} <br>
            <span class="pr-3 pr-md-4">{{ user.dob }}</span> {{ user.gender }} <br>
            {{ getAddress(user.attributes.address) }}
          </span>
        </div>
        <div class="blockButtons position-relative align-self-start">
          <button @click="editPage(1)" class="d-flex justify-content-center align-items-center">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 15 15" width="15" height="15"><g class="currentLayer"><g><path fill="#AA2D41" d="M13.1 5.9999996c-.1 0-.3 0-.4-.1l-3.2-3.2c-.1-.1-.1-.2-.1-.4s.1-.3.1-.4l1.3-1.3c.8-.8 2.1-.8 2.8 0l1.1 1.1c.8.8.8 2.1 0 2.8l-1.3 1.3c0 .2-.2.2-.3.2zm-2.5-3.7l2.5 2.5 1-1c.4-.4.4-1 0-1.4l-1.1-1.1c-.4-.4-1-.4-1.4 0l-1 1z"/><path fill="#AA2D41" d="M.5 15.3999996c-.1 0-.3-.1-.4-.1-.1-.2-.1-.3-.1-.5l.6-3.8c0-.1.1-.2.1-.3l8.8-8.8c.2-.2.5-.2.7 0l3.2 3.2c.1.1.1.2.1.4s-.1.3-.1.4l-8.8 8.8c-.1.1-.2.1-.3.1l-3.8.6c.1 0 0 0 0 0zm1.1-4.1l-.5 3 3-.5 8.3-8.3-2.5-2.5-8.3 8.3z"/><path fill="#AA2D41" d="M5.2 13.8999996c-.1 0-.3 0-.4-.1l-3.2-3.2c-.2-.2-.2-.5 0-.7s.5-.2.7 0l3.2 3.2c.2.2.2.5 0 .7 0 0-.1.1-.3.1z"/></g></g></svg>
          </button>
        </div>
      </div>

      <div v-if="secondaryInfo.length > 0">

        <hr class="my-4">

        <div class="d-flex justify-content-between">
          <div class="flex-grow-1">
            <h2 class="h5 mb-3">Your Members</h2>

            <div class="row">
              <div class="col-12 col-md-6 mb-3 text-muted" style="line-height: 1.7;" v-for="(secondary, secondaryIndex) in secondaryInfo" :key="secondaryIndex">
                {{ secondary.title }} {{ secondary.first_name }} {{ secondary.last_name }} <br>
                <span class="pr-3 pr-md-4">{{ secondary.dob }}</span> {{ secondary.gender }} <br>
              </div>
            </div>
          </div>
          <div class="blockButtons position-relative align-self-start">
            <button @click="editPage(2)" class="d-flex justify-content-center align-items-center">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 15 15" width="15" height="15"><g class="currentLayer"><g><path fill="#AA2D41" d="M13.1 5.9999996c-.1 0-.3 0-.4-.1l-3.2-3.2c-.1-.1-.1-.2-.1-.4s.1-.3.1-.4l1.3-1.3c.8-.8 2.1-.8 2.8 0l1.1 1.1c.8.8.8 2.1 0 2.8l-1.3 1.3c0 .2-.2.2-.3.2zm-2.5-3.7l2.5 2.5 1-1c.4-.4.4-1 0-1.4l-1.1-1.1c-.4-.4-1-.4-1.4 0l-1 1z"/><path fill="#AA2D41" d="M.5 15.3999996c-.1 0-.3-.1-.4-.1-.1-.2-.1-.3-.1-.5l.6-3.8c0-.1.1-.2.1-.3l8.8-8.8c.2-.2.5-.2.7 0l3.2 3.2c.1.1.1.2.1.4s-.1.3-.1.4l-8.8 8.8c-.1.1-.2.1-.3.1l-3.8.6c.1 0 0 0 0 0zm1.1-4.1l-.5 3 3-.5 8.3-8.3-2.5-2.5-8.3 8.3z"/><path fill="#AA2D41" d="M5.2 13.8999996c-.1 0-.3 0-.4-.1l-3.2-3.2c-.2-.2-.2-.5 0-.7s.5-.2.7 0l3.2 3.2c.2.2.2.5 0 .7 0 0-.1.1-.3.1z"/></g></g></svg>
            </button>
          </div>
        </div>

      </div>

      <hr class="my-4">

      <div class="row mt-3 mt-xl-4">
        <div class="col-12 d-lg-flex justify-content-end align-items-center">
          <button :class="['btn btn-block-mob mb-2 mb-lg-0 px-md-5', processing ? 'btn-primary-dark' : 'btn-primary']" type="submit" @click="saveData">
            {{ !processing ? 'Enter CampdraftONE' : '' }}
            <div v-if="processing" class="spinner-border text-light" role="status"><span class="sr-only">Loading...</span></div>
          </button>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  props: ['user'],
  data() {
    return {
      userInfo: this.user,
      secondaryInfo: this.user.secondaries ? this.user.secondaries : [],
      horseInfo: this.user.horses ? this.user.horses : [],
      processing: false
    }
  },
  mounted() { window.scrollTo(0, 0) },
  methods: {
    getAddress(theUserAddress) {
      let tempAddress = theUserAddress.street_1
      tempAddress = theUserAddress.street_2 ? `${tempAddress} ${theUserAddress.street_2}` : tempAddress
      tempAddress = theUserAddress.suburb ? `${tempAddress}, ${theUserAddress.suburb}` : tempAddress
      tempAddress = theUserAddress.postcode ? `${tempAddress}, ${theUserAddress.postcode}` : tempAddress
      tempAddress = theUserAddress.state ? `${tempAddress}, ${theUserAddress.state}` : tempAddress
      return tempAddress
    },
    saveData() {
      this.processing = true
      axios.post(`${this.$api}/onboarding/complete`).then((response) => {
        this.processing = false
        // eslint-disable-next-line
        // console.log(response)
        if (response.data.status === 'success') {
          // Done
          localStorage.setItem('is_onboarded', true)
          this.$router.push('/')
        }
      }).catch((error) => {
        this.processing = false
        // eslint-disable-next-line
        console.log(error)
      })
    },
    editPage(page) {
      this.$emit('proceed', page)
    }
  }
}
</script>

<style lang="scss" scoped>
.blockButtons {

  button {
    border-width: 1px;
    border-style: solid;
    border-color: var(--primary);
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Account/LoginOnce/LoginOnce4.vue